// eslint-disable-next-line import/prefer-default-export
export const listDistricts = /* GraphQL */ `
    query ListDistricts(
        $id: ID
        $filter: ModelDistrictFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
        $includeZone: Boolean = false
        $includeSchools: Boolean = false
    ) {
        listDistricts(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                slug
                beds
                name {
                    legal
                    popular
                }
                avatar {
                    size
                    name
                    src
                }
                zone @include(if: $includeZone) {
                    id
                    name
                }
                schools @include(if: $includeSchools) {
                    items {
                        id
                    }
                }
                state {
                    enabled
                }
                createdAt
                updatedAt
                districtZoneId
            }
            nextToken
        }
    }
`;

export const listZones = /* GraphQL */ `
    query ListZones(
        $id: ID
        $filter: ModelZoneFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listZones(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                name
            }
            nextToken
        }
    }
`;
export const updateDistrict = /* GraphQL */ `
    mutation UpdateDistrict(
        $input: UpdateDistrictInput!
        $condition: ModelDistrictConditionInput
    ) {
        updateDistrict(input: $input, condition: $condition) {
            id
            slug
            name {
                legal
                popular
            }
            avatar {
                size
                name
                src
            }
            zone {
                id
                name
            }
            schools {
                items {
                    id
                }
            }
            users {
                items {
                    id
                }
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;

export const onCreateDistrict = /* GraphQL */ `
    subscription OnCreateDistrict {
        onCreateDistrict {
            id
            slug
            name {
                legal
                popular
            }
            avatar {
                size
                name
                src
            }
            zone {
                id
                name
            }
            schools {
                items {
                    id
                }
            }
            users {
                items {
                    id
                }
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
export const onUpdateDistrict = /* GraphQL */ `
    subscription OnUpdateDistrict {
        onUpdateDistrict {
            id
            slug
            name {
                legal
                popular
            }
            avatar {
                size
                name
                src
            }
            zone {
                id
                name
            }
            schools {
                items {
                    id
                }
            }
            users {
                items {
                    id
                }
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
export const onDeleteDistrict = /* GraphQL */ `
    subscription OnDeleteDistrict {
        onDeleteDistrict {
            id
            slug
            name {
                legal
                popular
            }
            avatar {
                size
                name
                src
            }
            zone {
                id
                name
            }
            schools {
                items {
                    id
                }
            }
            users {
                items {
                    id
                }
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
